<template>
    <div style="width:100%;height:100vh;">
        <iframe v-if="!ios" :src="pdf" type="application/pdf" width="100%" height="100%"></iframe>
        <div class="flex mt-4 justify-center items-center flex-col" :key="i" v-for="(img,i) in imgs ">
            <img class
                 width="95%"
                 style="-webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);"
                 :src="`data:image/png;base64, ${img}`" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                idForm: "",
                pdf: "",
                imgs: [],
                ios: undefined
            };
        },
        created() {
            const { id, isIos, pdf } = this.$route.params;
            if (!isIos) {
                this.pdf = `data:application/pdf;base64, ${pdf}`;
            } else {
                this.ios = true;
                this.imgs = pdf;
            }
        }
    };
</script>

